<template>
    <div class="box">
        <inner-table id="innerFamily" ref="familyList" :exclude-fields="'column_operate'" :listviewurl="'studentFamilyMembers.list'" :can-edit="0" :can-delete="0" :link-prop-name="'studentId'" />
    </div>
</template>

<script>
export default {
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 0 }
    },
    data() {
        return {}
    },
    computed: {},
    watch: {},
    created: function () {},
    mounted: function () {},
    methods: {
        onInnerCellClick() {},
        onInnerTableListDataBeforeLoad($scope, qparams) {
            qparams.urlsearch = `studentId:${this.vo?.studentId}`
        },
        // 内嵌子表-子表单提交前回调
        onInnerBasicFormBeforeSubmit($scope, vo, defer) {
            vo.studentBasicInfoId = this.vo.id
            vo.studentId = this.vo.studentId
            defer.resolve(true)
        }
    }
}
</script>

<style scoped>
.header {
    padding: 10px 20px;
    background-color: #f2f5fb;
    font-size: 14px;
    font-weight: 500;
}
.box {
    border: 1px solid #999;
}
</style>
